import React from 'react';
import CountrySelectionPage from './pages/CountrySelectionPage/CountrySelectionPage';
import CountryPage from './pages/CountryPage/CountryPage';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";
import {englishTranslatedAssets, englishTranslations} from "./pages/CountryPage/Props/english";
import {germanTranslatedAssets, germanTranslations} from "./pages/CountryPage/Props/german";
import mixpanel from "mixpanel-browser";



mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as string, {
  debug: process.env.REACT_APP_MIXPANEL_DEBUG as string === "true",
  ip: false,
});



const App: React.FC = () => {
  let location = useLocation();

  React.useEffect(() => {
    mixpanel.track("pageview")
  }, [location]);

  return (
      <Routes>
        <Route path="/" element={<CountrySelectionPage />} />

        <Route path="/germany" element={<CountryPage translations={germanTranslations} assets={germanTranslatedAssets}/>} />
        <Route path="/germany/privacy-policy" element={<PrivacyPolicyPage countryCode="de" languageCode="de"/>} />

        <Route path="/uk" element={<CountryPage translations={englishTranslations} showSponsor={true} assets={englishTranslatedAssets}/>} />
        <Route path="/uk/privacy-policy" element={<PrivacyPolicyPage countryCode="gb" languageCode="en"/>} />

        <Route path="/australia" element={<CountryPage translations={englishTranslations} assets={englishTranslatedAssets}/>} />
        <Route path="/australia/privacy-policy" element={<PrivacyPolicyPage countryCode="au" languageCode="en"/>} />

        <Route path="/canada" element={<CountryPage translations={englishTranslations} assets={englishTranslatedAssets}/>} />
        <Route path="/canada/privacy-policy" element={<PrivacyPolicyPage countryCode="ca" languageCode="en"/>} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
  );
}

export default App;